import type { WorkspaceIMSnapshot } from './openim-types';

/** createInitialWorkspaceIMSnapshot 创建不伪造未读数的运行时初始快照。 */
export function createInitialWorkspaceIMSnapshot(): WorkspaceIMSnapshot {
  return {
    actionError: {},
    actionStatus: {},
    conversations: [],
    hasPreviousMessages: false,
    historyLoading: false,
    messages: [],
    status: 'idle',
  };
}

/** WorkspaceIMStore 以不可变快照向 Host 与 Remote 广播同一份消息事实。 */
export class WorkspaceIMStore {
  private listeners = new Set<() => void>();
  private snapshot = createInitialWorkspaceIMSnapshot();

  /** getSnapshot 返回 useSyncExternalStore 可比较的稳定引用。 */
  getSnapshot = (): WorkspaceIMSnapshot => this.snapshot;

  /** subscribe 注册快照监听并返回精确解绑函数。 */
  subscribe = (listener: () => void): (() => void) => {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  };

  /** patch 原子合并运行时状态并通知所有消费者。 */
  patch(values: Partial<WorkspaceIMSnapshot>): void {
    this.snapshot = { ...this.snapshot, ...values };
    this.listeners.forEach(listener => listener());
  }

  /** reset 清空上一个租户和用户的全部内存事实。 */
  reset(): void {
    this.snapshot = createInitialWorkspaceIMSnapshot();
    this.listeners.forEach(listener => listener());
  }
}
